module.exports = __webpack_public_path__ + "static/media/diaroogle_logo_medium.48c7e29c.jpg";